import $ from 'jquery';

const defaults = {
  expandClass: 'expand',
  button: '.block-title',
};

function Dropdown(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.toggle = $.proxy(this.toggle, this);
  this.$button = this.getButton();
  this.addListener();
}

Dropdown.prototype = {
  getButton() {
    return this.$element.find(this.settings.button);
  },
  toggle() {
    if (this.$element.hasClass(this.settings.expandClass)) {
      this.collapse();
    } else {
      this.expand();
    }
  },
  expand() {
    this.$element.addClass(this.settings.expandClass);
  },
  collapse() {
    this.$element.removeClass(this.settings.expandClass);
  },
  addListener() {
    this.$button.bind('click', this.toggle);
  },
};

export default Dropdown;



// WEBPACK FOOTER //
// ./Dropdown.js